"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.popup = void 0;
var utils_1 = require("../../utils");
exports.popup = function (axios) {
    return {
        getPopups: function (request) {
            return axios.get('/popups', request);
        },
        postPopups: function (request) {
            return axios.post('/popups', request.data);
        },
        deletePopups: function (request) {
            return axios.delete('/popups', request);
        },
        getPopupsExcel: function (request) {
            return axios.get('/popups/excel', request);
        },
        getPopupsPopupNo: function (request) {
            var url = utils_1.paramPathchange('/popups/{popupNo}', request);
            return axios.get(url);
        },
        putPopupsPopupNo: function (request) {
            var url = utils_1.paramPathchange('/popups/{popupNo}', request);
            return axios.put(url, request.data);
        },
        putPopupsPopupNoDisplayStatus: function (request) {
            var url = utils_1.paramPathchange('/popups/{popupNo}/display-status', request);
            return axios.put(url, request.data);
        }
    };
};
